import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const languages = [
    { code: 'tr', name: 'Türkçe', flag: '/flags/tr.svg' },
    { code: 'en', name: 'English', flag: '/flags/gb.svg' },
    { code: 'fr', name: 'Français', flag: '/flags/fr.svg' },
    { code: 'ru', name: 'Русский', flag: '/flags/ru.svg' },
    { code: 'ar', name: 'العربية', flag: '/flags/ar.svg' },
];

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages.find(l => l.code === i18n.languages[0].substring(0,2)) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Change language">
          <img src={currentLanguage.flag} alt={currentLanguage.name} className="w-6 h-auto rounded-sm" width={24} height={24} decoding="async" loading="lazy" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map(lang => (
          <DropdownMenuItem key={lang.code} onSelect={() => changeLanguage(lang.code)}>
            <img src={lang.flag} alt={lang.name} className="w-5 h-auto mr-2 rtl:mr-0 rtl:ml-2" width={20} height={20} decoding="async" loading="lazy" />
            <span>{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
